<template>
  <section>
    <error-display-component :serverErrors="serverErrors" :serverErrorMessage="serverErrorMessage" id="error-container"></error-display-component>
    <div v-show="isValidToken && !isLoading" class="hero">
      <div class="hero-body container container box has-background-white-bis">
        <div class="steps" id="stepsDemo">
          <div class="step-item is-active is-success">
            <div class="step-marker">1</div>
            <div class="step-details">
              <p class="step-title" style="text-decoration: none;" v-if="mobile">
                <i title="Customer" class="fal fa-user fa-lg"></i>
              </p>
              <p class="step-title" v-else>CUSTOMER</p>
            </div>
          </div>
          <div class="step-item">
            <div class="step-marker">2</div>
            <div class="step-details">
              <p class="step-title" style="text-decoration: none;" v-if="mobile">
                <i title="Residence" class="fal fa-home-alt fa-lg"></i>
              </p>
              <p class="step-title" v-else>RESIDENCE</p>
            </div>
          </div>
          <div class="step-item">
            <div class="step-marker">3</div>
            <div class="step-details">
              <p class="step-title" style="text-decoration: none;" v-if="mobile">
                <i title="Documents" class="fal fa-id-card fa-lg"></i>
              </p>
              <p class="step-title" v-else>DOCUMENTS</p>
            </div>
          </div>
          <div class="step-item">
            <div class="step-marker">4</div>
            <div class="step-details">
              <p class="step-title" style="text-decoration: none;" v-if="mobile">
                <i title="Terms" class="fal fa-file-signature fa-lg"></i>
              </p>
              <p class="step-title" v-else>TERMS</p>
            </div>
          </div>
          <div class="steps-content">
            <div class="step-content">
              <div class="credit-app has-background-grey-dark has-text-white">
                Please confirm your information
              </div>
              <form  v-if="currentCustomer" @submit.prevent="validateBeforeSubmit" class="has-text-centered is-active" data-vv-scope="step1">
                <section class="has-text-left box">
                  <div class="columns is-multiline">
                    <div class="column is-6">
                      <div class="field">
                        <label class="label">First Name<b-icon pack="fas" icon="star" class="fa-ss"></b-icon></label>
                        <div class="control">
                          <input name="firstName" v-validate="{'required': true, 'max': 15}" :class="{'input': true, 'is-danger': errors.has('step1.firstName') }" data-vv-scope="step1" data-vv-as="first name" type="text" placeholder="e.g John" v-model="currentCustomer.firstName" :disabled="true">
                          <span v-show="errors.has('step1.firstName')" class="help is-danger">
                            <i v-show="errors.has('step1.firstName')" class="fas fa-exclamation-triangle"></i>{{ errors.first('step1.firstName') }}
                          </span>
                        </div>
                      </div>
                    </div>
                    <div class="column is-6">
                      <div class="field">
                        <label class="label">Last Name<b-icon pack="fas" icon="star" class="fa-ss"></b-icon></label>
                        <div class="control">
                          <input name="lastName" v-validate="{'required': true, 'max': 25}" :class="{'input': true, 'is-danger': errors.has('step1.lastName') }" data-vv-scope="step1" data-vv-as="last name" type="text" placeholder="e.g Smith" v-model="currentCustomer.lastName" :disabled="true">
                          <span v-show="errors.has('step1.lastName')" class="help is-danger">
                            <i v-show="errors.has('step1.lastName')" class="fas fa-exclamation-triangle"></i>{{ errors.first('step1.lastName') }}
                          </span>
                        </div>
                      </div>
                    </div>
                    <label class="form-info has-text-info" style="padding-left: 15px;">Please Note: If you would like to change your first and last name, please contact your sales person for assistance.</label>
                    <div class="column is-12">
                      <div class="field">
                        <label class="label">Date of Birth<b-icon pack="fas" icon="star" class="fa-ss"></b-icon></label>
                        <div class="control has-icons-right">
                          <el-date-picker
                            name="dateOfBirth"
                            v-validate="{'required': true, 'minimum_age_18': true}"
                            :class="{'is-danger': errors.has('step1.dateOfBirth') }"
                            data-vv-scope="step1"
                            data-vv-as="date of birth"
                            size="large"
                            prefix-icon="none"
                            type="date"
                            format="MM-dd-yyyy"
                            placeholder="Click to select..."
                            v-model="currentCustomer.dateOfBirth"
                            :picker-options="datePickerOptions"
                            :clearable="false"
                            style="width: 100%;"
                            :default-value="defaultDate">
                          </el-date-picker>
                          <span v-show="errors.has('step1.dateOfBirth')" class="help is-danger">
                            <i v-show="errors.has('step1.dateOfBirth')" class="fas fa-exclamation-triangle"></i>{{ errors.first('step1.dateOfBirth') }}
                          </span>
                          <span class="icon is-small is-right">
                            <i class="fal fa-calendar-alt default-blue"></i>
                          </span>
                        </div>
                      </div>
                    </div>
                    <div class="column is-12">
                      <div class="field">
                        <label class="label">Social Security No.<b-icon pack="fas" icon="star" class="fa-ss"></b-icon></label>
                        <div class="control">
                          <input v-if="canEditSsn"
                            name="ssn"
                            data-vv-scope="step1"
                            data-vv-as="social security number"
                            :class="{'input': true, 'is-danger': errors.has('ssn') }"
                            type="text"
                            v-model="currentCustomer.ssn"
                            v-mask="'###-##-####'"
                            v-validate="'required|valid_ssn'"
                            :minlength="11"
                            >
                          <span v-else class="field is-size-7">{{ currentSsn }}</span>
                          <span v-show="errors.has('step1.ssn')" class="help is-danger">
                            <i v-show="errors.has('step1.ssn')" class="fas fa-exclamation-triangle"></i>{{ errors.first('step1.ssn') }}
                          </span>
                        </div>
                        <div class="field is-size-7 is-pulled-right mt-10">
                          <b-checkbox
                            :native-value="false"
                            name="chkEditSsn"
                            type="is-info"
                            v-model="canEditSsn">
                            <span class="has-text-info">Edit SSN</span>
                          </b-checkbox>
                        </div>
                      </div>
                    </div>
                    <div v-if="!itemsHidden">
                      <div class="columns is-multiline">
                        <div class="column is-12">
                          <div class="field">
                            <label class="label">Driver's License No.<b-icon pack="fas" icon="star" class="fa-ss"></b-icon></label>
                            <div class="control">
                              <input name="driverLicenseNumber" v-validate="{'required': !itemsHidden, 'min': 15, 'max': 15}" :class="{'input': true, 'is-danger': errors.has('step1.driverLicenseNumber') }" data-vv-scope="step1" data-vv-as="driver's license" type="text" placeholder="Driver's License No." v-model="currentCustomer.driverLicenseNumber">
                              <span v-show="errors.has('step1.driverLicenseNumber')" class="help is-danger">
                                <i v-show="errors.has('step1.driverLicenseNumber')" class="fas fa-exclamation-triangle"></i>{{ errors.first('step1.driverLicenseNumber') }}
                              </span>
                            </div>
                          </div>
                        </div>
                        <div class="column is-12">
                          <div class="field">
                            <label class="label">Driver's License - Issuing State<b-icon pack="fas" icon="star" class="fa-ss"></b-icon></label>
                            <div class="control">
                              <multiselect
                                :multiple="false"
                                id="customerDriverLicenseState"
                                name="customerDriverLicenseState"
                                v-validate="!itemsHidden"
                                :class="errors.has('step1.customerDriverLicenseState') ? 'is-danger': ''"
                                data-vv-scope="step1"
                                data-vv-as="driver's license state"
                                placeholder="Select State"
                                label="text"
                                track-by="value"
                                :options="stateOptions"
                                :searchable="false"
                                v-model="customerDriverLicenseState">
                              </multiselect>
                              <span v-show="errors.has('step1.customerDriverLicenseState')" class="help is-danger">
                                <i v-show="errors.has('step1.customerDriverLicenseState')" class="fas fa-exclamation-triangle"></i> {{ errors.first('step1.customerDriverLicenseState') }}
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="column is-12">
                      <div class="field">
                        <label class="label">Email<b-icon pack="fas" icon="star" class="fa-ss"></b-icon></label>
                        <div class="control has-icons-right">
                          <input name="email" v-validate="{'required': true, 'email': true, 'max': 50}" :class="{'input': true, 'is-danger': errors.has('step1.email') }" data-vv-scope="step1" data-vv-as="email" type="email" placeholder="Email" v-model="currentCustomer.email">
                          <span v-show="errors.has('step1.email')" class="help is-danger">
                            <i v-show="errors.has('step1.email')" class="fas fa-exclamation-triangle"></i>{{ errors.first('step1.email') }}
                          </span>
                          <span class="icon is-small is-right">
                            <i class="fal fa-envelope default-blue"></i>
                          </span>
                        </div>
                      </div>
                    </div>
                    <div class="column is-12">
                      <div class="field">
                        <label class="label">Home Phone<b-icon pack="fas" icon="star" class="fa-ss"></b-icon></label>
                        <div class="control has-icons-right">
                          <input name="home" v-validate="{'required': true, 'min': 16, 'max': 16}" :class="{'input': true, 'is-danger': errors.has('step1.home') }" data-vv-scope="step1" data-vv-as="home phone" type="tel" placeholder="+1(999)-999-9999" v-mask="'+1(###)-###-####'" v-model="currentCustomer.home">
                          <span v-show="errors.has('step1.home')" class="help is-danger">
                            <i v-show="errors.has('step1.home')" class="fas fa-exclamation-triangle"></i>{{ errors.first('step1.home') }}
                          </span>
                          <span class="icon is-small is-right">
                            <i class="fal fa-phone-volume default-blue"></i>
                          </span>
                        </div>
                      </div>
                    </div>
                    <div class="column is-12">
                      <div class="field">
                        <label class="label">Mobile Phone</label>
                        <div class="control has-icons-right">
                          <input name="mobile" v-validate="{'min': 16, 'max': 16}" :class="{'input':true, 'is-danger': errors.has('step1.mobile') }" data-vv-scope="step1" data-vv-as="mobile phone" type="tel" placeholder="+1(999)-999-9999" v-mask="'+1(###)-###-####'" v-model="currentCustomer.mobile">
                          <span v-show="errors.has('step1.mobile')" class="help is-danger">
                            <i v-show="errors.has('step1.mobile')" class="fas fa-exclamation-triangle"></i>{{ errors.first('step1.mobile') }}
                          </span>
                          <span class="icon is-small is-right">
                            <i class="fal fa-mobile-android default-blue"></i>
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
              </form>
            </div>
            <div class="step-content">
              <form class="has-text-centered" data-vv-scope="step2">
                <section class="has-text-left">
                  <div class="credit-app has-background-grey-dark has-text-white">
                    <p>Address where vehicle will be registered. Must be an address owned or rented by you</p>
                  </div>
                  <div v-for="(address, index) in addresses" :key="address.id">
                    <address-capture v-model="addresses[index]" :addressIndex="index" :verification="true" scope="step2" :required="true" :useValidator="thisValidator"></address-capture>
                    <br/>
                  </div>
                  <div class="inner-add-remove-button customButtonContainer">
                    <b-button icon-left="fa fa-lg fa-plus-circle" class="customButtons" type="is-info" inverted @click="addAddress({})">Add</b-button>
                    <b-button icon-left="fa fa-lg fa-minus-circle" class="customButtons" type="is-danger" inverted v-if="showRemoveAddress" @click="removeAddress({})">Remove</b-button>
                  </div>
                </section>
              </form>
            </div>
            <div class="step-content">
              <form class="has-text-centered" data-vv-scope="step3">
                <section class="has-text-left">
                  <div class="credit-app has-background-grey-dark has-text-white">
                    Please provide driver's license and insurance card
                  </div>
                <div class="is-full">
                  <div class="field is-full">
                    <file-selector v-model="driversPhotoFiles" label="Drivers License" :multiple="false" :token="this.token" scope="step3" destinationUrl="/upload/receive"></file-selector>
                  </div>
                  <div class="field is-full" v-if="stateRequiredBackOfDriversLicense">
                    <file-selector v-model="backOfDriversPhotoFiles" label="Back Of Drivers License" :multiple="false" :token="this.token" scope="step3" destinationUrl="/upload/receive"></file-selector>
                  </div>
                  <div class="field is-full">
                    <file-selector v-model="insurancePhotoFiles" label="Insurance Card" :multiple="false" :token="this.token" scope="step3" destinationUrl="/upload/receive"></file-selector>
                  </div>
                </div>
                </section>
              </form>
            </div>
            <div class="step-content">
              <form class="has-text-centered" data-vv-scope="step4">
                <section class="has-text-left">
                  <div class="credit-app has-background-grey-dark has-text-white">
                    Please review and accept the terms and conditions
                  </div>
                  <div v-observe-visibility="visibilityChanged">
                    <div class="field">
                      <generic-terms-control v-model="currentCustomer.isTermsAccepted"></generic-terms-control>
                    </div>
                  </div>
                </section>
              </form>
            </div>
          </div>
          <div class="steps-actions">
            <div class="steps-action">
              <b-button icon-left="chevron-left" data-nav="previous" class="is-light" :disabled="hasSaved">Previous</b-button>
            </div>
            <div class="steps-action">
              <b-button icon-right="chevron-right" data-nav="next" class="next-step"  @click='validateStep' :disabled="hasSaved">Next</b-button>
            </div>
            <div class="steps-action" v-if="termsVisible && canSave">
              <a class="button next-step" @click="validateBeforeSubmit" :disabled="hasSaved">Submit</a>
            </div>
          </div>
          <div class="container" v-if="isValidToken && customerFirstNameValid && customerLastNameValid && customerEmailValid">
            <b-button type="is-text" @click="saveAndContinueLaterValidate" :disabled="hasSaved">Save and <span class="form-info">continue later</span></b-button>
          </div>
        </div>
      </div>
    </div>
    <div v-show="!isValidToken && isLoading" class="hero">
      <div class="hero-body container">
        <div class="container is-fluid">
          <div class="columns is-vcentered loadingContainer">
            <div class="column is-12 has-text-centered has-text-weight-semi-bold">
              <img src="@/assets/ajax-loader.gif">
              <div v-if="!loadingBaseData">Verifying your identity....</div>
              <div v-if="loadingBaseData">Loading base data....</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-show="!isValidToken && !isLoading" class= "hero">
      <div class="hero-body container"></div>
    </div>
  </section>
</template>

<script>
import bulmaSteps from 'bulma-steps/dist/js/bulma-steps'
import customerService from '@/services/customerService'
import addressCapture from '@/components/generic/AddressCapture'
import customerMixin from '@/mixins/customer/index'
import validateBeforeSubmitMixin from '@/mixins/generic/validateBeforeSubmit'
import ErrorDisplayComponent from '@/components/generic/ErrorDisplayComponent'
import FileSelector from '@/components/generic/FileSelector'
import utilitiesMixin from '@/mixins/generic/utilities'
import { mapActions } from 'vuex'
import GenericTermsControl from '@/components/generic/GenericTermsControl'

export default {
  name: 'IdentityVerification',
  inject: {
    $validator: '$validator'
  },
  props: {
    token: {
      type: String,
      default: ''
    }
  },
  components: {
    'address-capture': addressCapture,
    'error-display-component': ErrorDisplayComponent,
    'file-selector': FileSelector,
    'generic-terms-control': GenericTermsControl
  },
  mixins: [validateBeforeSubmitMixin, customerMixin, utilitiesMixin],
  data () {
    return {
      mobile: window.innerWidth <= 700,
      isLoading: false,
      itemsHidden: true,
      addresses: [],
      currentStep: 0,
      termsVisible: false,
      customerDriverLicenseState: {},
      isSaving: false,
      todayDate: new Date(),
      allStates: [],
      canSave: false,
      serverErrors: [],
      serverErrorMessage: '',
      isValidToken: false,
      preventClick: false,
      loadingBaseData: false,
      dealerId: 0,
      hasSaved: false,
      driversPhotoFiles: [],
      insurancePhotoFiles: [],
      customerEmailValid: false,
      customerFirstNameValid: false,
      customerLastNameValid: false,
      reg: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/,
      currentUrl: '',
      currentCustomer: {
        subscriberId: 0,
        dealerId: 0,
        type: null,
        status: null,
        companyName: null,
        firstName: null,
        name: null,
        middleName: null,
        lastName: null,
        fullName: null,
        displayName: null,
        initials: null,
        email: null,
        mobile: null,
        office: null,
        home: null,
        fax: null,
        addresses: [],
        workHistory: [],
        creditApplications: [],
        personalReferences: [],
        relatives: [],
        imageName: null,
        fileName: null,
        fileLocation: null,
        driversImageName: null,
        driversFileName: null,
        driversFileLocation: null,
        dealerName: null,
        subscriberName: null,
        uploadName: null,
        uniqueId: null,
        driversUploadName: null,
        driversUniqueId: null,
        bankId: 0,
        accountNo: null,
        accountHolder: null,
        accountType: null,
        branchNo: null,
        branchName: null,
        swiftNo: null,
        bankName: null,
        ssn: null,
        applicationReferenceNumber: null,
        dateOfBirth: null,
        driverLicenseNumber: null,
        driverLicenseState: null,
        latestCreditApplicationId: 0,
        isCreditContinueLater: false,
        isPartial: false,
        insuranceImageName: null,
        insuranceFileName: null,
        insuranceFileLocation: null,
        insuranceUploadName: null,
        insuranceUniqueId: null,
        isTermsAccepted: false,
        termsAcceptedAt: null,
        defaultPaymentMethod: null,
        regulationB: false,
        communityPropertyDisclosure: false,
        totalYears: 0,
        totalMonths: 0,
        totalPeriod: 0,
        ofacRequested: false,
        ofacRequestedAt: null,
        ofacStatus: null,
        isContinueLater: false,
        url: null,
        isCopState: false,
        isCreditApplicationComplete: false,
        leadId: '',
        customerId: null,
        agentUserId: '',
        agentLocationId: 0,
        ipAddress: null,
        localAddr: null,
        localLatitude: null,
        localLongitude: null,
        make: 0,
        makeName: null,
        model: null,
        year: null,
        vinNo: null,
        makes: [],
        models: [],
        states: [],
        submitAction: 'Save',
        id: 0,
        createdAt: null,
        modifiedAt: null,
        ssnRequired: false,
        backOfDriversImageName: '',
        backOfDriversFileName: '',
        backOfDriversFileLocation: '',
        backOfDriversUploadName: '',
        backOfDriversUniqueId: '',
        decryptedSsn: ''
      },
      datePickerOptions: {
        disabledDate (date) {
          return date > new Date()
        },
        defaultView: 'year'
      },
      availableScopes: ['step1', 'step2', 'step3', 'step4'],
      currentSsn: '',
      canEditSsn: false,
      backOfDriversPhotoFiles: []
    }
  },
  computed: {
    stateOptions: function () {
      return this.allStates.map(d => ({ text: d.text, value: d.value }))
    },
    currentCustomerFirstName: function () {
      return this.currentCustomer ? this.currentCustomer.firstName || '' : ''
    },
    currentCustomerLastName: function () {
      return this.currentCustomer ? this.currentCustomer.lastName || '' : ''
    },
    isTermsAccepted: function () {
      return this.currentCustomer ? Boolean(this.currentCustomer.isTermsAccepted) : false
    },
    currentCustomerEmail: function () {
      return this.currentCustomer ? this.currentCustomer.email || '' : ''
    },
    customerUrl () {
      return this.$store.currentUrl
    },
    fullName () {
      if (!this.currentCustomer) {
        return ''
      }
      const first = this.currentCustomer.firstName || ''
      const last = this.currentCustomer.lastName || ''
      return [first, last].filter(Boolean).join(' ').trim()
    },
    thisValidator: function () {
      return (this && this.$validator) ? this.$validator : null
    },
    currentScope: function () {
      return this.availableScopes[this.currentStep]
    },
    stateRequiredBackOfDriversLicense: function () {
      if (this.addresses && this.addresses[0] && this.addresses[0].state) {
        const state = this.addresses[0].state
        return state.isBackOfDriversLicenseRequiredState
      }
      return false
    },
    showRemoveAddress: function () {
      return this.checkRemoveButtonVisibility(this.addresses)
    }
  },
  methods: {
    ...mapActions(['updateReturnUrl', 'updateIsContinueLater']),
    fetchIdentityVerification: function (currentToken) {
      this.serverErrorMessage = ''
      this.loadingBaseData = true
      this.isLoading = true
      customerService.getCustomerIdentityVerification(currentToken).then(response => {
        this.currentCustomer = {
          ...response.customerdata
        }
        this.dealerId = this.currentCustomer.dealerId
        if (!this.dealerId || this.dealerId === 0) {
          this.serverErrorMessage = 'Could not load customer with token: ' + currentToken
        } else {
          this.isValidToken = true
          this.isLoading = false
          this.initInputValues()
        }
      // eslint-disable-next-line handle-callback-err
      }).catch((error) => {
        this.isLoading = false
        this.serverErrorMessage = 'Could not load customer with token: ' + currentToken
        this.isValidToken = false
      })
    },
    initInputValues () {
      if (this.currentCustomer != null) {
        this.addresses = []
        this.currentCustomer.addresses.forEach(function (address) {
          var config = {
            sectionId: this.addresses.length + 100,
            loadCustomerOnly: false
          }
          address.config = config
          this.addresses.push(address)
        }, this)
        if (this.currentCustomer.driversFileLocation) {
          var driversPhotoFile = {
            loaded: true,
            imageData: this.currentCustomer.driversFileLocation,
            fileName: this.currentCustomer.driversFileName,
            fileLocation: this.currentCustomer.driversFileLocation,
            name: this.currentCustomer.driversImageName,
            fileType: this.getFileType(this.currentCustomer.driversFileLocation)
          }

          this.driversPhotoFiles.push(driversPhotoFile)
        }
        if (this.currentCustomer.backOfDriversFileLocation) {
          var backOfDriversPhotoFile = {
            loaded: true,
            imageData: this.currentCustomer.backOfDriversFileLocation,
            fileName: this.currentCustomer.backOfDriversFileName,
            fileLocation: this.currentCustomer.backOfDriversFileLocation,
            name: this.currentCustomer.driversImageName,
            fileType: this.getFileType(this.currentCustomer.backOfDriversFileLocation)
          }

          this.backOfDriversPhotoFiles.push(backOfDriversPhotoFile)
        }
        if (this.currentCustomer.insuranceFileLocation) {
          var insurancePhotoFile = {
            loaded: true,
            imageData: this.currentCustomer.insuranceFileLocation,
            fileName: this.currentCustomer.insuranceFileName,
            fileLocation: this.currentCustomer.insuranceFileLocation,
            name: this.currentCustomer.insuranceImageName,
            fileType: this.getFileType(this.currentCustomer.insuranceImageName)
          }

          this.insurancePhotoFiles.push(insurancePhotoFile)
        }

        if (this.addresses.length === 0) {
          this.addAddress({})
        }
        this.canEditSsn = this.currentCustomer.ssn === ''
        this.currentSsn = this.currentCustomer.ssn
      } else {
        this.serverErrorMessage = 'Could not load customer information'
      }
    },
    visibilityChanged (isVisible, entry) {
      this.termsVisible = isVisible
    },
    fetchAllStates: function () {
      customerService.allStates().then(response => {
        this.allStates = response.results
      }).catch((error) => {
        this.serverErrorMessage = error.message
      })
    },
    onSave: function () {
      this.currentCustomer.isContinueLater = false
      this.save()
    },
    evaluateRequiredTermsVisibility () {
      this.evaluateValidToSubmitCheck()
    },
    evaluateValidToSubmitCheck () {
      this.canSave = Boolean(this.currentCustomer && this.currentCustomer.isTermsAccepted)
    },
    onComplete () {
      if (this.currentCustomer.isContinueLater) {
        this.$router.push({ name: 'IdentityVerificationContinueLater' })
      } else {
        this.$router.push({ name: 'IdentityVerificationComplete' })
      }
    },
    resetCurrentCustomer () {
      this.currentCustomer = {
        subscriberId: 0,
        dealerId: 0,
        type: null,
        status: null,
        companyName: null,
        firstName: null,
        name: null,
        middleName: null,
        lastName: null,
        fullName: null,
        displayName: null,
        initials: null,
        email: null,
        mobile: null,
        office: null,
        home: null,
        fax: null,
        addresses: [],
        workHistory: [],
        creditApplications: [],
        personalReferences: [],
        relatives: [],
        imageName: null,
        fileName: null,
        fileLocation: null,
        driversImageName: null,
        driversFileName: null,
        driversFileLocation: null,
        dealerName: null,
        subscriberName: null,
        uploadName: null,
        uniqueId: null,
        driversUploadName: null,
        driversUniqueId: null,
        bankId: 0,
        accountNo: null,
        accountHolder: null,
        accountType: null,
        branchNo: null,
        branchName: null,
        swiftNo: null,
        bankName: null,
        ssn: null,
        applicationReferenceNumber: null,
        dateOfBirth: null,
        driverLicenseNumber: null,
        driverLicenseState: null,
        latestCreditApplicationId: 0,
        isCreditContinueLater: false,
        isPartial: false,
        insuranceImageName: null,
        insuranceFileName: null,
        insuranceFileLocation: null,
        insuranceUploadName: null,
        insuranceUniqueId: null,
        isTermsAccepted: false,
        termsAcceptedAt: null,
        defaultPaymentMethod: null,
        regulationB: false,
        communityPropertyDisclosure: false,
        totalYears: 0,
        totalMonths: 0,
        totalPeriod: 0,
        ofacRequested: false,
        ofacRequestedAt: null,
        ofacStatus: null,
        isContinueLater: false,
        url: null,
        isCopState: false,
        isCreditApplicationComplete: false,
        leadId: '',
        customerId: null,
        agentUserId: '',
        agentLocationId: 0,
        ipAddress: null,
        localAddr: null,
        localLatitude: null,
        localLongitude: null,
        make: 0,
        makeName: null,
        model: null,
        year: null,
        vinNo: null,
        makes: [],
        models: [],
        states: [],
        submitAction: 'Save',
        id: 0,
        createdAt: null,
        modifiedAt: null,
        ssnRequired: false,
        backOfDriversImageName: '',
        backOfDriversFileName: '',
        backOfDriversFileLocation: '',
        backOfDriversUploadName: '',
        backOfDriversUniqueId: '',
        decryptedSsn: ''
      }
    },
    saveAndContinueLaterValidate: function () {
      const that = this
      this.$validator.validate(this.currentScope + '.*').then((result) => {
        if (result === false) {
          that.$goToFirstValidationError(that.$validator.errors.items.filter((x) => x.scope === that.currentScope))
        } else {
          that.saveAndContinueLater()
        }
      })
    },
    async saveAndContinueLater () {
      this.currentCustomer.isContinueLater = true
      this.currentCustomer.url = this.currentUrl
      await this.updateReturnUrl(this.currentUrl)
      await this.updateIsContinueLater(true)
      this.save()
    },
    save () {
      var customerModel = {
        subscriberId: this.currentCustomer.subscriberId,
        dealerId: this.currentCustomer.dealerId,
        type: this.currentCustomer.type,
        status: this.currentCustomer.status,
        companyName: this.currentCustomer.companyName,
        firstName: this.currentCustomer.firstName,
        name: this.currentCustomer.name,
        middleName: this.currentCustomer.middleName,
        lastName: this.currentCustomer.lastName,
        fullName: this.currentCustomer.fullName,
        displayName: this.currentCustomer.displayName,
        initials: this.currentCustomer.initials,
        email: this.currentCustomer.email,
        mobile: this.currentCustomer.mobile,
        office: this.currentCustomer.office,
        home: this.currentCustomer.home,
        fax: this.currentCustomer.fax,
        addresses: [],
        workHistory: [],
        creditApplications: [],
        personalReferences: [],
        relatives: [],
        imageName: null,
        fileName: null,
        fileLocation: null,
        driversImageName: null,
        driversFileName: null,
        driversFileLocation: null,
        dealerName: this.currentCustomer.dealerName,
        subscriberName: this.currentCustomer.subscriberName,
        uploadName: null,
        uniqueId: null,
        driversUploadName: null,
        driversUniqueId: null,
        bankId: this.currentCustomer.bankId || 0,
        accountNo: this.currentCustomer.accountNo,
        accountHolder: this.currentCustomer.accountHolder,
        accountType: this.currentCustomer.accountType,
        branchNo: this.currentCustomer.branchNo,
        branchName: this.currentCustomer.branchName,
        swiftNo: this.currentCustomer.swiftNo,
        bankName: this.currentCustomer.bankName,
        ssn: this.currentCustomer.ssn || '',
        applicationReferenceNumber: this.currentCustomer.applicationReferenceNumber,
        dateOfBirth: this.currentCustomer.dateOfBirth,
        driverLicenseNumber: this.currentCustomer.driverLicenseNumber || '',
        driverLicenseState: this.currentCustomer.driverLicenseState || '',
        latestCreditApplicationId: this.currentCustomer.latestCreditApplicationId,
        isCreditContinueLater: this.currentCustomer.isCreditContinueLater,
        isPartial: this.currentCustomer.isPartial,
        insuranceImageName: null,
        insuranceFileName: null,
        insuranceFileLocation: null,
        insuranceUploadName: null,
        insuranceUniqueId: null,
        isTermsAccepted: this.currentCustomer.isTermsAccepted,
        termsAcceptedAt: this.currentCustomer.termsAcceptedAt,
        defaultPaymentMethod: this.currentCustomer.defaultPaymentMethod,
        regulationB: this.currentCustomer.regulationB,
        communityPropertyDisclosure: this.currentCustomer.communityPropertyDisclosure,
        totalYears: this.currentCustomer.totalYears || 0,
        totalMonths: this.currentCustomer.totalMonths || 0,
        totalPeriod: this.currentCustomer.totalPeriod || 0,
        ofacRequested: this.currentCustomer.ofacRequested,
        ofacRequestedAt: this.currentCustomer.ofacRequestedAt,
        ofacStatus: this.currentCustomer.ofacStatus,
        isContinueLater: this.currentCustomer.isContinueLater,
        url: this.currentCustomer.url,
        id: this.currentCustomer.id,
        createdAt: this.currentCustomer.createdAt,
        modifiedAt: this.currentCustomer.modifiedAt,
        ssnRequired: this.currentCustomer.ssnRequired,
        backOfDriversImageName: this.currentCustomer.backOfDriversImageName,
        backOfDriversFileName: this.currentCustomer.backOfDriversFileName,
        backOfDriversFileLocation: this.currentCustomer.backOfDriversFileLocation,
        backOfDriversUploadName: this.currentCustomer.backOfDriversUploadName,
        backOfDriversUniqueId: this.currentCustomer.backOfDriversUniqueId,
        decryptedSsn: this.currentCustomer.decryptedSsn,
        token: this.token,
        submit: 'Accept/Submit'
      }
      this.hasSaved = true

      this.saveAddress(customerModel)

      customerModel.uploadName = this.currentCustomer.uploadName
      customerModel.uniqueId = this.currentCustomer.uniqueId

      if (this.driversPhotoFiles.length > 0) {
        var driversPhotoFile = this.driversPhotoFiles.filter((y) => !y.id || y.id <= 0).map((x) => {
          return {
            uploadName: x.name,
            uniqueId: x.uniqueId
          }
        })

        customerModel.driversUploadName = driversPhotoFile[0].uploadName
        customerModel.driversUniqueId = driversPhotoFile[0].uniqueId
      } else {
        customerModel.driversUploadName = ''
        customerModel.driversUniqueId = ''
      }

      if (this.backOfDriversPhotoFiles.length > 0) {
        var backOfDriversPhotoFile = this.backOfDriversPhotoFiles.filter((y) => !y.id || y.id <= 0).map((x) => {
          return {
            uploadName: x.name,
            uniqueId: x.uniqueId
          }
        })

        customerModel.backOfDriversUploadName = backOfDriversPhotoFile[0].uploadName
        customerModel.backOfDriversUniqueId = backOfDriversPhotoFile[0].uniqueId
      } else {
        customerModel.backOfDriversUploadName = ''
        customerModel.backOfDriversUniqueId = ''
      }

      if (this.insurancePhotoFiles.length > 0) {
        var insurancePhotoFile = this.insurancePhotoFiles.filter((y) => !y.id || y.id <= 0).map((x) => {
          return {
            uploadName: x.name,
            uniqueId: x.uniqueId
          }
        })

        customerModel.insuranceUploadName = insurancePhotoFile[0].uploadName
        customerModel.insuranceUniqueId = insurancePhotoFile[0].uniqueId
      } else {
        customerModel.insuranceUploadName = ''
        customerModel.insuranceUniqueId = ''
      }

      this.isSaving = true
      this.serverErrorMessage = ''
      this.serverErrors = []

      customerService.updateIdentityVerification(customerModel).then(response => {
        this.isSaving = false
        if (response.errors) {
          this.serverErrors = response.errors
          this.$nextTick(function () {
            var elmnt = document.getElementById('main-page')
            elmnt.scrollTo(0, 0)
          })
          this.hasSaved = false
        } else {
          this.$emit('on-save', response.customer)
          this.onChangesSaved()
          this.onComplete()
          this.hasSaved = false
        }
      }).catch((error) => {
        this.serverErrorMessage = error.message
        this.isSaving = false
        this.$nextTick(function () {
          var elmnt = document.getElementById('main-page')
          elmnt.scrollTo(0, 0)
        })
        this.hasSaved = false
      })
    },
    async validateStep (e) {
      this.preventClick = false
      this.$validator.validate(this.currentScope + '.*').then((result) => {
        if (result === false) {
          this.preventClick = true
          this.$goToFirstValidationError(this.$validator.errors.items.filter((x) => x.scope === this.currentScope))
        }
      })
    },
    checkRemoveButtonVisibility (dataCollection) {
      if (dataCollection.length > 1) {
        return true
      }
      return false
    }
  },
  created () {
    this.currentUrl = window.location.href
    this.$emit('is-home', false)
  },
  mounted () {
    bulmaSteps.attach('.steps', {
      beforeNext: id => {
        var beforeNextResult = {}
        if (this.preventClick) {
          beforeNextResult.errors = ['Error occured']
          return beforeNextResult
        } else {
          return beforeNextResult
        }
      },
      beforePrevious: id => {
        this.currentStep = id
      },
      onShow: id => {
        var elmnt = document.getElementById('main-page')
        elmnt.scrollTo(0, 0)
        this.currentStep = id
      }
    })
    this.fetchAllStates()
    this.resetCurrentCustomer()
    this.fetchIdentityVerification(this.token)
    this.$emit('set-title-one', 'IDENTITY')
    this.$emit('set-title-two', 'VERIFICATION')
  },
  watch: {
    isTermsAccepted () {
      this.evaluateValidToSubmitCheck()
    },
    token: function (newValue, oldValue) {
      this.isValidToken = false
      this.fetchAllStates()
      this.fetchIdentityVerification(this.token)
    },
    currentCustomerFirstName () {
      this.customerFirstNameValid = this.currentCustomerFirstName.length > 1
    },
    currentCustomerLastName () {
      this.customerLastNameValid = this.currentCustomerLastName.length > 1
    },
    currentCustomerEmail () {
      const email = this.currentCustomerEmail
      this.customerEmailValid = email.length > 1 && this.reg.test(email)
    }
  }
}

</script>

<style scoped>

</style>
